module.exports = __webpack_public_path__ + "static/img/so3_6.fbff82a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/pic/so3_6.jpg
// module id = f576
// module chunks = 11